import { X } from "lucide-react";
import { BulkResizeImage } from "@/store/features/bulkResize/types";
import { BulkResizerRotateSettings } from "./RotateSettings/BulkResizerRotateSettings";
import { BulkResizerFlipSettings } from "./FlipSettings/BulkResizerFlipSettings";
import { Translate } from "@/components/common/Translate/Translate";
import { Navigation } from "../Navigation/Navigation";
import { Modal } from "@/components/common/Modal/Modal";

interface FlipRotateModalProps {
    image: BulkResizeImage;
    isOpen: boolean;
    onClose: () => void;
}

const FlipRotateModal = ({ image, isOpen, onClose }: FlipRotateModalProps) => {
    return (
        <Modal isOpen={isOpen} close={onClose} closeOnOverlayClick={false}>
            <div className="bg-white flex flex-col dark:bg-darkSurface-100 dark:border-2 dark:border-darkSurface-400 max-h-[calc(100vh-120px)] md:min-h-[80vh]  rounded-lg w-full max-w-[900px] mx-4 overflow-hidden">
                <div className="flex justify-between items-center p-4 border-b dark:border-darkSurface-400">
                    <h3 className="text-lg lg:text-2xl font-semibold dark:text-white">
                        <Translate keyName="rotate-and-flip-image" />
                    </h3>
                    <Navigation imageId={image.id} operation="flip-rotate" />
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                        data-testid="remove-image-from-flip"
                    >
                        <X />
                    </button>
                </div>

                <div className="flex flex-grow flex-col md:flex-row max-h-full overflow-hidden">
                    <div className="md:w-2/3 h-[40vh] md:h-auto md:max-h-full border-r dark:border-darkSurface-400 p-4 flex items-center justify-center bg-gray-50 dark:bg-darkSurface-200">
                        <img
                            src={image.preview.src}
                            key={image.preview.src}
                            className="max-h-full max-w-full object-contain"
                        />
                    </div>

                    <div className="md:w-1/3 flex flex-col overflow-hidden">
                        <div className="flex-grow overflow-y-auto pb-4">
                            <BulkResizerRotateSettings imageId={image.id} />
                            <BulkResizerFlipSettings imageId={image.id} />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const BulkResizerSingleImageRotateModalWrapper = (props: FlipRotateModalProps) => {
    if (!props.isOpen) return null;
    return <FlipRotateModal {...props} />;
};

export default BulkResizerSingleImageRotateModalWrapper;
